import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { SET_AUTH, SET_CORRECTION_QUERY, SET_IS_SEND_ANALYTICS, SET_SEARCH_QUERY } from "../actions/actionTypes";
export default function (state, action) {
  switch (action.type) {
    case SET_SEARCH_QUERY:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          search: _objectSpread(_objectSpread({}, state.search), {}, {
            query: action.payload
          })
        });
      }
    case SET_CORRECTION_QUERY:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          search: _objectSpread(_objectSpread({}, state.search), {}, {
            correction: action.payload || ''
          })
        });
      }
    case SET_AUTH:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          search: _objectSpread(_objectSpread({}, state.search), {}, {
            account: action.payload
          })
        });
      }
    case SET_IS_SEND_ANALYTICS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          search: _objectSpread(_objectSpread({}, state.search), {}, {
            isNotSendAnalytics: action.payload
          })
        });
      }
    default:
      return state;
  }
}